<template>
  <div class="g-bd" style="background: #fff">
    <div class="course-index">
      <div class="item-left">
        <div style="background: #fff">
          <div class="con-tag">
            <p class="title-tool"><a href="/index">首页</a> &gt; 全部课程</p>
            <!-- 课程类别选项 -->
            <div class="con-tagsList f-clearfix" style="display: flex">
              <span class="title-lable" style="margin-top: 10px"
                >课程类别：</span
              >
              <categoryList
                class="tagsList-item f-clearfix"
                ref="childList"
                :list="categoryOptions"
                :tabs="activeName"
                :urlFlag="categoryFlag"
                :flagNum="categoryNum"
                :allList="categoryOptions"
                @getNewList="getNewList"
                @getHotList="getHotList"
              ></categoryList>
            </div>
            <el-divider></el-divider>

            <!-- 所属院校 -->
            <div class="con-tagsList f-clearfix" style="display: flex">
              <span class="title-lable" style="margin-top: 10px"
                >所属院校：</span
              >
              <div class="ismany">
                <categoryList
                  class="tagsList-item f-clearfix"
                  :class="isAllSchoolFlag ? 'all' : 'lettle'"
                  ref="childList"
                  :list="courseSchoolOptions"
                  :tabs="activeName"
                  :urlFlag="schoolFlag"
                  :flagNum="schoolNum"
                  :allList="courseSchoolOptions"
                  @getNewList="getNewList"
                  @getHotList="getHotList"
                ></categoryList>
                <div
                  v-if="!isAllSchoolFlag"
                  class="isshow"
                  @click="isAllSchool()"
                >
                  <el-button>更多 <i class="el-icon-arrow-down"></i></el-button>
                </div>
                <div v-else class="isshow" @click="isAllSchool()">
                  <el-button>收起 <i class="el-icon-arrow-up"></i></el-button>
                </div>
              </div>
            </div>
            <el-divider></el-divider>
            <!-- 课程层次 -->
            <div class="con-tagsList f-clearfix" style="display: flex">
              <span class="title-lable" style="margin-top: 10px"
                >课程层次：</span
              >
              <categoryList
                class="tagsList-item f-clearfix"
                ref="childList"
                :list="tagCourse"
                :tabs="activeName"
                :urlFlag="tagCourseFlag"
                :flagNum="tagCourseFlagNum"
                :allList="tagCourse"
                @getNewList="getNewList"
                @getHotList="getHotList"
              ></categoryList>
            </div>
            <el-divider></el-divider>
            <!-- 所属项目 -->
            <div class="con-tagsList f-clearfix" style="display: flex">
              <span class="title-lable" style="margin-top: 10px"
                >所属项目：</span
              >
              <categoryList
                class="tagsList-item f-clearfix"
                ref="childList"
                :list="tagProject"
                :tabs="activeName"
                :urlFlag="tagProjectFlag"
                :flagNum="tagProjectFlagNum"
                :allList="tagProject"
                @getNewList="getNewList"
                @getHotList="getHotList"
              ></categoryList>
            </div>
            <el-divider></el-divider>
            <!-- 课程状态选项 -->
            <div class="con-tagsList f-clearfix" style="display: flex">
              <span class="title-lable" style="margin-top: 10px"
                >课程状态：</span
              >
              <categoryList
                class="tagsList-item f-clearfix"
                ref="childList"
                :list="courseStatusList"
                :tabs="activeName"
                :urlFlag="statusFlag"
                :flagNum="statusNum"
                :allList="courseStatusList"
                @getNewList="getNewList"
                @getHotList="getHotList"
              ></categoryList>
            </div>
            <el-divider></el-divider>
            <div class="title-item"></div>
          </div>
        </div>
        <div class="con-course-body con-course-flex">
          <div class="con-list item-flex">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="最新" name="2"></el-tab-pane>
              <el-tab-pane label="最热" name="1"></el-tab-pane>
            </el-tabs>
            <div v-if="activeName == 2">
              <div v-if="noData == true" class="no-data">
                <h2>暂无相关内容</h2>
              </div>
              <ul class="con-course f-clearfix" v-loading="loading">
                <li
                  v-for="(item, index) in newTableList"
                  :key="index"
                  :title="item.name"
                >
                  <div
                    v-if="item.tagId != null"
                    id="item-course-tags-b"
                    :class="
                      item.tagId == '1169810873999269889'
                        ? 'tagA'
                        : item.tagId == '1242344957122658306'
                        ? 'tagB'
                        : 'tagC'
                    "
                  ></div>
                  <div
                    v-if="item.tagId != null"
                    id="item-course-tags"
                    :class="
                      item.tagId == '1169810873999269889'
                        ? 'tagA'
                        : item.tagId == '1242344957122658306'
                        ? 'tagB'
                        : 'tagC'
                    "
                  >
                    <span :title="item.tagTitle">{{ item.tagTitle }}</span>
                    <!-- <span v-else-if="item.tagTitle == '1242344957122658306'">{{
                      item.tagTitle
                    }}</span> -->
                  </div>
                  <a :href="item.ctUrl" target="_blank">
                    <div class="item-img">
                      <img v-img.lazy="item.ctImgUrl" :alt="item.name" />
                    </div>
                    <h3>{{ item.name }}</h3>
                    <div class="item-teacher">
                      <span class="item-school">{{ item.teacherName }}</span>
                    </div>
                    <div>
                      <span class="item-school">{{ item.schoolName }}</span>
                      <span class="item-edu">
                        {{ item.enrollCount || 0 }}人选课
                      </span>
                    </div>
                  </a>
                </li>
              </ul>

              <div class="m-pagination-wrapper">
                <el-pagination
                  class="m-pagination"
                  @current-change="newPage"
                  :page-size="newPageList.pageSize"
                  :hide-on-single-page="true"
                  :current-page.sync="newPageList.pageNo"
                  :total="newPageList.total"
                  layout=" prev, pager, next"
                ></el-pagination>
              </div>
            </div>
            <div v-if="activeName == 1">
              <div v-if="noData1 == true" class="no-data">
                <h2>暂无相关内容</h2>
              </div>
              <ul class="con-course f-clearfix">
                <li
                  v-for="(item, index) in hotTableList"
                  :key="index"
                  :title="item.name"
                >
                  <div
                    v-if="item.tagId != null"
                    id="item-course-tags-b"
                    :class="
                      item.tagId == '1169810873999269889'
                        ? 'tagA'
                        : item.tagId == '1242344957122658306'
                        ? 'tagB'
                        : 'tagC'
                    "
                  ></div>
                  <div
                    v-if="item.tagId != null"
                    id="item-course-tags"
                    :class="
                      item.tagId == '1169810873999269889'
                        ? 'tagA'
                        : item.tagId == '1242344957122658306'
                        ? 'tagB'
                        : 'tagC'
                    "
                  >
                    <span :title="item.tagTitle">{{ item.tagTitle }}</span>
                    <!-- <span v-else-if="item.tagTitle == '1242344957122658306'">{{
                      item.tagTitle
                    }}</span> -->
                  </div>
                  <a :href="item.ctUrl" target="_blank">
                    <div class="item-img">
                      <img v-img.lazy="item.ctImgUrl" :alt="item.name" />
                    </div>
                    <h3>{{ item.name }}</h3>
                    <div class="item-teacher">
                      <span class="item-school">{{ item.teacherName }}</span>
                    </div>
                    <div>
                      <span class="item-school">{{ item.schoolName }}</span>
                      <span class="item-edu">
                        {{ item.enrollCount || 0 }}人选课
                      </span>
                    </div>
                  </a>
                </li>
              </ul>
              <div class="m-pagination-wrapper">
                <el-pagination
                  class="m-pagination"
                  @current-change="hotPage"
                  :page-size="hotPageList.pageSize"
                  :hide-on-single-page="true"
                  :current-page.sync="hotPageList.pageNo"
                  :total="hotPageList.total"
                  layout=" prev, pager, next"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item-right">
        <div class="con-rank">
          <rankCourse class=""></rankCourse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import rankCourse from "./rankCourse.vue";
import categoryList from "./categoryList.vue";
import merge from "webpack-merge";
export default {
  components: {
    categoryList,
    rankCourse,
  },
  name: "course",
  data() {
    return {
      categoryFlag: "category",
      schoolFlag: "school",
      tagCourseFlag: "tagCourseFlag",
      tagProjectFlag: "tagProjectFlag",
      statusFlag: "status",
      categoryNum: 0,
      schoolNum: 0,
      tagCourseFlagNum: 0,
      tagProjectFlagNum: 0,
      statusNum: 0,
      noData: false,
      noData1: false,
      loading: false,
      activeName: "2",
      newTableList: [],
      hotTableList: [],
      tableForm: {
        categoryId: "",
        tagList: "",
        search: "",
        status: 1,
      },
      newPageList: {
        pageNo: 1,
        pageSize: 40,
        total: 0,
      },
      hotPageList: {
        pageNo: 1,
        pageSize: 40,
        total: 0,
      },
      categoryOptions: [],
      categoryId: "",
      //课程状态
      courseStatusList: [
        { title: "全部", id: 0 },
        { title: "进行中", id: 1 },
        { title: "即将开始", id: 2 },
        { title: "已结束", id: 3 },
      ],
      statusId: 0,
      // 课程类别分级赋值
      courseSchoolOptions: [],
      isAllSchoolFlag: false,
      collegeId: "",
      //课程层次
      tagCourse: [],
      tagCourseId: "",
      // 课程所属项目
      tagProject: [],
      tagProjectId: "",
    };
  },
  mounted() {
    this.tableForm.search = this.$route.query.key;
    let pathFalg = this.$route.query.pathFalg;
    let query = this.$route.query;
    this.categoryId = query.categoryId;
    this.collegeId = query.collegeId;
    this.statusId = query.status;
    this.tagCourseId = query.tagCourseId;
    this.tagProjectId = query.tagProjectId;
    this.getCategoryList();
    this.getSchoolList();
    this.getTagCourse();
    this.getTagProject();
    if (pathFalg == "hot") {
      this.activeName = "1";
      this.getHotList();
    } else {
      this.activeName = "2";
      this.getNewList();
    }
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name;
      if (tab.name == 2) {
        this.getNewList();
      } else {
        this.getHotList();
      }
    },
    newPage(val) {
      this.newPageList.pageNo = val;
      this.getNewList();
    },
    hotPage(val) {
      this.hotPageList.pageNo = val;
      this.getHotList();
    },
    // 获取标签列表
    isAllSchool() {
      this.isAllSchoolFlag = !this.isAllSchoolFlag;
    },
    // 获取院校列表
    getSchoolList() {
      let par = {
        pageSize: 9999,
        currentPage: 1,
        parentId: null,
      };
      this.$http
        .post("api/manage/university/list", par)
        .then((res) => {
          let tree = res.data.records;
          // tree.splice(0, 1);
          this.courseSchoolOptions = this.$utils.list.toTree(tree);
          this.courseSchoolOptions.unshift({
            id: "",
            flag: "all",
            title: "全部",
          });
          let tagFlag = [];
          this.courseSchoolOptions.forEach(function (item, index) {
            if (item.childrenList != undefined) {
              // 原始数据处理
              let childIds = [];
              for (let i = 0; i < item.childrenList.length; i++) {
                childIds.push(item.childrenList[i].id);
              }
              tagFlag.push("all");
              item.childrenList.unshift({
                id: "",
                flag: "all",
                title: "全部",
              });
            } else {
              // this.courseSchoolOptions.splice(index, 1);
            }
          });
        })
        .catch((msg) => {});
    },

    //获取分类列表
    getCategoryList() {
      let par = {
        type: 1,
      };
      this.$http
        .post("api/manage/category/courseList", par)
        .then((res) => {
          this.categoryOptions = this.removeChildren(0, res.data);
        })
        .catch((msg) => {});
    },
    removeChildren(id, tree) {
      tree.unshift({
        title: "全部",
        id: id,
        childrenList: [],
      });
      const newTree = tree.map((item) => {
        if (item.childrenList.length === 0) {
          delete item.childrenList;
          return item;
        } else {
          return {
            ...item,
            childrenList: this.removeChildren(item.id, item.childrenList),
          };
        }
      });
      return newTree;
    },
    // 课程层次
    getTagCourse() {
      let par = {
        type: "COURSE",
      };
      this.$http
        .get("api/manage/tag/list", { params: par })
        .then((res) => {
          this.tagCourse = this.removeChildren(0, res.data);
        })
        .catch((msg) => {});
    },
    // 课程所属项目
    getTagProject() {
      let par = {
        type: "PROJECT",
      };
      this.$http
        .get("api/manage/tag/list", { params: par })
        .then((res) => {
          this.tagProject = this.removeChildren(0, res.data);
        })
        .catch((msg) => {});
    },
    //最热课程
    getHotList(val) {
      let tagList = [];
      this.hotTableList=[];
      // this.hotPageList.total = 0;
      // this.hotPageList.pageNo = 1
      let tagProjectList = [];
      if (val != undefined && val.flag == "category") {
        this.categoryId = val.id;
      } else if (val != undefined && val.flag == "school") {
        this.collegeId = val.id;
      } else if (val != undefined && val.flag == "status") {
        this.statusId = val.id;
      } else if (val != undefined && val.flag == "tagCourseFlag") {
        this.tagCourseId = val.id;
      } else if (val != undefined && val.flag == "tagProjectFlag") {
        this.tagProjectId = val.id;
      }
      if (this.tagCourseId != "") {
        tagProjectList.push(this.tagCourseId);
      }
      if (this.tagProjectId != "") {
        tagList.push(this.tagProjectId);
      }
      this.noData = false;
      let par = {
        pageSize: this.hotPageList.pageSize,
        currentPage: this.hotPageList.pageNo,
        categoryId: this.categoryId,
        sortType: 1,
        search: this.tableForm.search,
        tagProjectList: tagProjectList,
        tagList: tagList,
        status: this.statusId,
        collegeId: this.collegeId,
      };
      this.$http
        .post("api/web/course/list", par)
        .then((res) => {
          this.hotTableList = res.data.records;
          this.hotPageList.total = res.data.total;
          this.hotPageList.pageNo = res.data.current;
          if (res.data.records == "") {
            this.noData = true;
          }
        })
        .catch((msg) => {
          console.log(msg);
        });
    },
    //最新课程
    getNewList(val) {
      let tagList = [];
      this.newTableList=[];
      // this.newPageList.total = 0;
      // this.newPageList.pageNo = 1
      let tagProjectList = [];
      if (val != undefined && val.flag == "category") {
        this.categoryId = val.id;
      } else if (val != undefined && val.flag == "school") {
        this.collegeId = val.id;
      } else if (val != undefined && val.flag == "status") {
        this.statusId = val.id;
      } else if (val != undefined && val.flag == "tagCourseFlag") {
        this.tagCourseId = val.id;
      } else if (val != undefined && val.flag == "tagProjectFlag") {
        this.tagProjectId = val.id;
      }
      if (this.tagCourseId != "") {
        tagProjectList.push(this.tagCourseId);
      }
      if (this.tagProjectId != "") {
        tagList.push(this.tagProjectId);
      }
      this.noData = false;
      let par = {
        pageSize: this.newPageList.pageSize,
        currentPage: this.newPageList.pageNo,
        categoryId: this.categoryId,
        sortType: 2,
        search: this.tableForm.search,
        tagProjectList: tagProjectList,
        tagList: tagList,
        status: this.statusId,
        collegeId: this.collegeId,
      };
      this.$http
        .post("api/web/course/list", par)
        .then((res) => {
          this.newTableList = res.data.records;
          this.newPageList.total = res.data.total;
          this.newPageList.pageNo = res.data.current;
          if (res.data.records == "") {
            this.noData = true;
          }
        })
        .catch((msg) => {
          console.log(msg);
        });
    },
  },
};
</script>
<style lang="scss">
.course-index {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .item-left {
    flex: 1;
    max-width: 925px;
    margin-right: 10px;
  }
  .item-right {
    flex: 1;
    max-width: 284px;
    margin-top: 20px;
  }
}
.con-tag {
  width: 100%;
  margin: 0 auto;
  padding-right: 10px;
  .title-tool {
    font-size: 14px;
    color: #777;
    line-height: 20px;
    padding: 30px 0 15px;
  }
  span {
    line-height: 30px;
    font-size: 14px;
  }
  .title-lable {
    display: inline-block;
    height: auto;
    max-width: 285px;
    white-space: nowrap;
  }
  .tagsList-item {
    display: inline-block;
    &.all {
      max-height: 160px;
      overflow: auto;
    }
    &.lettle {
      max-height: 80px;
      overflow: hidden;
    }
  }
  .item-list {
    display: inline-block;
  }
  .title-item {
    margin-left: 30px;
    cursor: pointer;
    display: inline-block;
    &:hover {
      color: #3685fd;
    }
  }
  // 课程标签
  .con-tagsList {
    mark {
      width: 100%;
      height: auto;
    }
    li {
      list-style: none;
      width: auto;
      height: auto;
      display: flex;
      margin-top: 10px;
    }
    a {
      font-size: 14px;
      display: inline-block;
      text-decoration: none;
      padding: 4px 15px;
      // margin-left: 20px;
    }
    .active {
      background: #3685fd33;
      color: #3685fd;
      border-radius: 15px;
    }
    .ismany {
      display: flex;
      flex: 1;
      justify-content: space-between;
      div {
        flex: 1;
      }
      .isshow {
        max-width: 80px;
        height: 34px;
        margin-top: 10px;
        .el-button {
          padding: 0 10px;
        }
      }
    }
  }
  .el-divider {
    margin: 10px 0;
  }
}
.con-course-flex {
  display: flex;
  justify-content: space-between;
  .item-flex {
    flex: 1;
    // max-width: 900px !important;
    .con-course {
      width: 100%;
      padding: 0 -32px;
      margin-left: 0;
      :nth-child(4n) {
        margin-right: 0px;
      }
      li {
        width: 210px;
        margin-right: 19px;
        margin-left: 0;
        margin-bottom: 25px;
        .item-img {
          width: 210px;
          height: 120px;
          img {
            width: 100%;
          }
        }
          .item-teacher{
            height: 20px;
          }
        div {
          // height: 40px;
          // line-height: 40px;
          span {
            color: #777;
            font-size: 12px;
          }

          .item-school {
            float: left;
            width: 120px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .item-edu {
            float: right;
            text-align: right;
          }
        }
      }
    }
  }
  .con-rank {
    flex: 1;
    min-width: 280px;
    max-width: 280px;
    .con-list {
      width: 280px;
    }
  }
}
</style>
